import { render, staticRenderFns } from "./InvestmentCompletedStep.vue?vue&type=template&id=fa287ede&scoped=true"
import script from "./InvestmentCompletedStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestmentCompletedStep.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InvestmentCompletedStep.vue?vue&type=style&index=0&id=fa287ede&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa287ede",
  null
  
)

export default component.exports